module.exports = __webpack_public_path__ + "img/Insughts.34d708e8.png";